import { selectAudienceSorted } from '@mm/state/selectors/messengerAdSelectors';
import * as queryString from 'query-string';
import { useSelector } from 'react-redux';
import useRouter from 'use-react-router';

const parseAudienceId = (search: string): number | undefined => {
  const { audienceId } = queryString.parse(search);
  return audienceId ? parseInt(String(audienceId), 10) : undefined;
};

export const useLeadContactsFilter = () => {
  const { history, location } = useRouter();
  const { search } = location;
  const audiences = useSelector(selectAudienceSorted);
  const activeAudienceId = parseAudienceId(search);
  const activeAudience = audiences.find(
    audience => audience.id === activeAudienceId,
  );

  const setSearchParams = (params: Record<string, any>) => {
    const searchParams = queryString.parse(search);
    history.push({
      ...location,
      search: queryString.stringify({
        ...searchParams,
        ...params,
      }),
    });
  };

  const setAudienceId = (audienceId: number | undefined) =>
    setSearchParams({ audienceId });

  return {
    activeAudience,
    audiences,
    activeAudienceId,
    setAudienceId,
  };
};
